var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconlyBoldSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bold_Send",
    "data-name": "Iconly/Bold/Send",
    transform: "translate(-2 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Send",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M19.435.582A1.933,1.933,0,0,0,17.5.079L1.408,4.76A1.919,1.919,0,0,0,.024,6.281a2.253,2.253,0,0,0,1,2.1L6.06,11.477a1.3,1.3,0,0,0,1.61-.193l5.763-5.8a.734.734,0,0,1,1.06,0,.763.763,0,0,1,0,1.067l-5.773,5.8a1.323,1.323,0,0,0-.193,1.619L11.6,19.054A1.91,1.91,0,0,0,13.263,20a2.073,2.073,0,0,0,.25-.01A1.949,1.949,0,0,0,15.144,18.6L19.916,2.525a1.964,1.964,0,0,0-.48-1.943",
    transform: "translate(0 -1)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconlyBoldSend);
export default __webpack_public_path__ + "static/media/Iconly-Bold-Send.cba9f8c4d12ebb8ab22b9d5e854d05ce.svg";
export { ForwardRef as ReactComponent };